import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class CalendarSubscribeModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "httpUrl", '');
    _defineProperty(this, "webcalUrl", '');
    _defineProperty(this, "googleUrl", '');
    _defineProperty(this, "copied", false);
    _defineProperty(this, "copyTimeout", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const seasonSlug = this.attrs && this.attrs.seasonSlug || '';
    const baseUrl = window.location.origin;
    const icsPath = seasonSlug ? "/calendar/".concat(seasonSlug, "/").concat(clubSlug, ".ics") : "/calendar/".concat(clubSlug, ".ics");
    const currentLocale = app.translator && app.translator.locale || 'es';
    const localeQuery = currentLocale && currentLocale.startsWith('eu') ? '?locale=eu' : '';
    this.httpUrl = "".concat(baseUrl).concat(icsPath).concat(localeQuery);
    this.webcalUrl = this.httpUrl.replace(/^https?:\/\//i, 'webcal://');
    this.googleUrl = "https://calendar.google.com/calendar/render?cid=".concat(encodeURIComponent(this.webcalUrl));
  }
  className() {
    return 'CalendarSubscribeModal Modal--medium';
  }
  title() {
    return m("span", null, m("i", {
      className: "far fa-calendar-alt",
      style: "margin-right: 8px; color: #ee2524;"
    }), app.translator.trans('nagusi-match-ratings.forum.calendar.sync_modal_title', {}, 'Sincronizar Calendario'));
  }
  copyToClipboard() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.httpUrl).then(() => {
        this.copied = true;
        m.redraw();
        if (this.copyTimeout) clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
          m.redraw();
        }, 2500);
      });
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = this.httpUrl;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.copied = true;
        m.redraw();
        if (this.copyTimeout) clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
          m.redraw();
        }, 2500);
      } catch (err) {
        console.error('No se pudo copiar el enlace', err);
      }
      document.body.removeChild(textArea);
    }
  }
  content() {
    return m("div", {
      className: "Modal-body",
      style: "padding: 24px; display: flex; flex-direction: column; gap: 20px;"
    }, m("p", {
      style: "margin: 0; color: var(--muted-color); font-size: 0.98em; line-height: 1.5;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_modal_desc', {}, 'Suscríbete una sola vez y tendrás los partidos siempre actualizados en tu móvil u ordenador con horarios confirmados, resultados, enlaces a 11 Aldeanos, valoraciones y notas.')), m("div", {
      style: "display: flex; flex-direction: column; gap: 12px;"
    }, m("a", {
      href: this.googleUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--primary",
      style: "display: flex; align-items: center; justify-content: center; gap: 12px; padding: 13px 18px; border-radius: 10px; font-weight: bold; width: 100%; text-decoration: none; background: #1a73e8; border: 1px solid #1a73e8; color: #fff; font-size: 1.02em; box-shadow: 0 2px 6px rgba(26,115,232,0.25);"
    }, m("i", {
      className: "fab fa-google",
      style: "font-size: 1.1em;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_google_btn', {}, 'Añadir a Google Calendar'))), m("a", {
      href: this.webcalUrl,
      className: "Button Button--secondary",
      style: "display: flex; align-items: center; justify-content: center; gap: 12px; padding: 13px 18px; border-radius: 10px; font-weight: bold; width: 100%; text-decoration: none; font-size: 1.02em; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fab fa-apple",
      style: "font-size: 1.2em;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_apple_btn', {}, 'Apple Calendar (iPhone, iPad, Mac)')))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; padding: 16px;"
    }, m("div", {
      style: "font-weight: 600; margin-bottom: 8px; font-size: 0.9em; color: var(--heading-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_outlook_btn', {}, 'Outlook u otros gestores (URL de suscripción)'), ":"), m("div", {
      style: "display: flex; gap: 8px;"
    }, m("input", {
      type: "text",
      readOnly: true,
      value: this.httpUrl,
      className: "FormControl",
      style: "border-radius: 8px; font-family: monospace; font-size: 0.88em; cursor: pointer;",
      onclick: e => e.target.select()
    }), m(Button, {
      className: "Button ".concat(this.copied ? 'Button--success' : 'Button--secondary'),
      icon: this.copied ? 'fas fa-check' : 'far fa-copy',
      onclick: this.copyToClipboard.bind(this),
      style: "border-radius: 8px; white-space: nowrap; min-width: 100px; font-weight: bold;"
    }, this.copied ? app.translator.trans('nagusi-match-ratings.forum.calendar.sync_copied', {}, '¡Copiado!') : app.translator.trans('nagusi-match-ratings.forum.calendar.sync_copy_url', {}, 'Copiar'))), m("div", {
      style: "margin-top: 10px; display: flex; justify-content: space-between; align-items: center; font-size: 0.85em; flex-wrap: wrap; gap: 6px;"
    }, m("span", {
      style: "color: var(--muted-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_download_ask', {}, '¿Prefieres descargarlo como archivo?')), m("a", {
      href: this.httpUrl,
      download: true,
      style: "color: #60a5fa; text-decoration: underline; font-weight: 500;"
    }, m("i", {
      className: "fas fa-download",
      style: "margin-right: 4px;"
    }), app.translator.trans('nagusi-match-ratings.forum.calendar.sync_download_ics', {}, 'Descargar .ics'))), m("div", {
      style: "margin-top: 10px; background: rgba(245, 158, 11, 0.1); border-left: 3px solid #f59e0b; border-radius: 6px; padding: 8px 12px; font-size: 0.82em; line-height: 1.4; color: var(--text-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_download_warning', {}, '⚠️ Si descargas el archivo en lugar de suscribirte, el calendario quedará fijo y NO se actualizará cuando cambien los horarios, se jueguen partidos o se añadan enlaces y notas.'))), m("div", {
      style: "background: rgba(238, 37, 35, 0.08); border-left: 4px solid #ee2524; border-radius: 8px; padding: 12px 16px; font-size: 0.88em; line-height: 1.5; color: var(--text-color);"
    }, m("div", {
      style: "font-weight: bold; margin-bottom: 4px; display: flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-info-circle",
      style: "color: #ee2524;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_info_title', {}, 'Sincronización automática:'))), m("div", null, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_info_text', {}, 'Google Calendar actualiza las suscripciones de forma orientativa cada 12 - 24 horas. En Apple Calendar y Outlook puedes configurar el refresco cada hora para tener los cambios de horario y resultados al momento.'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/calendar/CalendarSubscribeModal', CalendarSubscribeModal);